/* ============================================
   MT-PARSER v4.0 - PARSER PROFESIONAL MT4/MT5
   ?? CAMBIOS: Guardar en USD, calcular % din�micamente
   ============================================ */

const PARSER_CONFIG = {
    logLevel: 'none',
    maxHeaderSearchLines: 30,
    minColumns: 5,
    minBalance: 100,
    maxBalance: 100000000
};

const LOG_LEVELS = { none: 0, error: 1, warn: 2, info: 3, debug: 4 };

class Logger {
    constructor(level = 'info') {
        this.level = LOG_LEVELS[level] || LOG_LEVELS.info;
        this.logs = [];
    }
    
    log(level, message, data = null) {
        if (LOG_LEVELS[level] <= this.level) {
            const emoji = { error: '?', warn: '??', info: '??', debug: '??' }[level] || '??';
            this.logs.push({ level, message, data, timestamp: new Date().toISOString() });
        }
    }
    
    error(msg, data) { this.log('error', msg, data); }
    warn(msg, data) { this.log('warn', msg, data); }
    info(msg, data) { this.log('info', msg, data); }
    debug(msg, data) { this.log('debug', msg, data); }
    getLogs() { return this.logs; }
}

// ============================================
// UTILIDADES
// ============================================

function cleanNumber(str) {
    if (str === null || str === undefined || str === '') return null;
    
    const strValue = str.toString().trim();
    if (strValue === '' || strValue === '-' || strValue === '�') return null;
    
    let cleaned = strValue.replace(/[$���??]/g, '');
    
    if (cleaned.startsWith('(') && cleaned.endsWith(')')) {
        cleaned = '-' + cleaned.slice(1, -1);
    }
    
    const hasCommaDecimal = /,\d{1,2}$/.test(cleaned);
    
    if (hasCommaDecimal) {
        cleaned = cleaned.replace(/\./g, '').replace(',', '.');
    } else {
        cleaned = cleaned.replace(/,/g, '');
    }
    
    cleaned = cleaned.replace(/\s/g, '');
    const num = parseFloat(cleaned);
    return isNaN(num) ? null : num;
}

function detectDirection(typeStr) {
    if (!typeStr) return 'LONG';
    const normalized = typeStr.toString().toLowerCase().trim();
    const sellTerms = ['sell', 'venta', 'short', 'put', 'out'];
    return sellTerms.some(term => normalized.includes(term)) ? 'SHORT' : 'LONG';
}

function normalizeSymbol(symbol) {
    if (!symbol) return '';
    let cleaned = symbol.toString().toUpperCase().trim();
    cleaned = cleaned.replace(/\.(m|raw|ecn|pro|mini|c)$/i, '');
    cleaned = cleaned.replace(/^#/, '');
    return cleaned;
}

function generateId() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
}

function parseDateTime(dateTimeStr) {
    if (!dateTimeStr || dateTimeStr === '' || dateTimeStr === '-') return null;
    
    try {
        let str = dateTimeStr.toString().trim().replace(/\s+/g, ' ');
        let dateStr = str;
        let timeStr = '00:00:00';
        
        const parts = str.split(' ');
        if (parts.length >= 2) {
            dateStr = parts[0];
            timeStr = parts[1];
            if (timeStr.split(':').length === 2) timeStr += ':00';
        }
        
        let year, month, day;
        
        if (dateStr.match(/^\d{4}[.\-\/]\d{2}[.\-\/]\d{2}$/)) {
            [year, month, day] = dateStr.split(/[.\-\/]/);
        } else if (dateStr.match(/^\d{2}[.\-\/]\d{2}[.\-\/]\d{4}$/)) {
            [day, month, year] = dateStr.split(/[.\-\/]/);
        } else if (dateStr.match(/^\d{1,2}\/\d{1,2}\/\d{4}$/)) {
            const dateParts = dateStr.split('/');
            month = dateParts[0].padStart(2, '0');
            day = dateParts[1].padStart(2, '0');
            year = dateParts[2];
        } else if (dateStr.match(/^\d{8}$/)) {
            year = dateStr.substr(0, 4);
            month = dateStr.substr(4, 2);
            day = dateStr.substr(6, 2);
        } else {
            const directDate = new Date(dateStr);
            if (!isNaN(directDate.getTime())) {
                return {
                    date: directDate.toISOString().split('T')[0],
                    time: directDate.toTimeString().slice(0, 8)
                };
            }
            return null;
        }
        
        const isoString = `${year}-${month}-${day}T${timeStr}`;
        const date = new Date(isoString);
        
        if (isNaN(date.getTime())) return null;
        
        return {
            date: date.toISOString().split('T')[0],
            time: timeStr.slice(0, 5)
        };
    } catch (error) {
        return null;
    }
}

function detectFormat(content) {
    const trimmed = content.trim().toLowerCase();
    return (trimmed.includes('<html') || trimmed.includes('<table') || trimmed.includes('<!doctype')) ? 'html' : 'csv';
}

function detectBalance(content, logger) {
    const patterns = [
        /balance[:\s]+\$?\s*([\d\s,]+\.?\d*)/i,
        /saldo[:\s]+\$?\s*([\d\s,]+\.?\d*)/i,
        /<td[^>]*>Balance:<\/td>\s*<td[^>]*><b>([\d\s,]+\.?\d*)<\/b>/i,
        /patrimonio[:\s]+<[^>]*><b>([\d\s,]+\.?\d*)<\/b>/i,
    ];
    
    for (const pattern of patterns) {
        const match = content.match(pattern);
        if (match && match[1]) {
            const value = cleanNumber(match[1]);
            if (value && value >= PARSER_CONFIG.minBalance && value <= PARSER_CONFIG.maxBalance) {
                logger.info(`Balance detectado: ${value.toFixed(2)}`);
                return value;
            }
        }
    }
    
    logger.warn('No se pudo detectar el balance autom�ticamente');
    return null;
}

// ============================================
// ?? DETECCI�N INTELIGENTE DE COLUMNAS
// ============================================

function getVisibleCells(row) {
    const allCells = Array.from(row.querySelectorAll('td, th'));
    return allCells.filter(cell => {
        if (cell.classList.contains('hidden')) return false;
        
        const colspan = parseInt(cell.getAttribute('colspan')) || 1;
        const content = cell.textContent.trim();
        
        if (colspan >= 5 && content === '') return false;
        
        return true;
    });
}

function validateCellContent(value, expectedType) {
    if (!value || value === '' || value === '-') return { valid: false, score: 0 };
    
    const str = value.toString().trim().toLowerCase();
    
    switch (expectedType) {
        case 'ticket':
            const isTicket = /^\d{6,10}$/.test(str.replace(/\s/g, ''));
            return { valid: isTicket, score: isTicket ? 10 : 0 };
            
        case 'symbol':
            const isSymbol = /^[A-Z]{6,10}$/i.test(str) || /^#?[A-Z]+$/i.test(str);
            return { valid: isSymbol, score: isSymbol ? 10 : 0 };
            
        case 'type':
            const hasDirection = ['buy', 'sell', 'long', 'short', 'compra', 'venta', 'in', 'out']
                .some(term => str.includes(term));
            return { valid: hasDirection, score: hasDirection ? 10 : 0 };
            
        case 'volume':
            const vol = cleanNumber(str);
            const isVolume = vol !== null && vol > 0 && vol <= 100;
            const scoreBonus = (vol >= 0.01 && vol <= 10) ? 2 : 0;
            return { valid: isVolume, score: isVolume ? (8 + scoreBonus) : 0 };
            
        case 'openTime':
        case 'closeTime':
            const parsed = parseDateTime(str);
            return { valid: parsed !== null, score: parsed ? 10 : 0 };
            
        case 'openPrice':
        case 'closePrice':
            const price = cleanNumber(str);
            const isPrice = price !== null && price > 0 && price < 1000000;
            const decimalPlaces = str.match(/\.(\d+)/)?.[1]?.length || 0;
            const hasCorrectPrecision = decimalPlaces >= 2 && decimalPlaces <= 5;
            return { valid: isPrice, score: isPrice ? (hasCorrectPrecision ? 9 : 5) : 0 };
            
        case 'commission':
        case 'swap':
            const comm = cleanNumber(str);
            return { valid: comm !== null, score: comm !== null ? 7 : 0 };
            
        case 'profit':
            const profit = cleanNumber(str);
            return { valid: profit !== null, score: profit !== null ? 8 : 0 };
            
        default:
            return { valid: false, score: 0 };
    }
}

function smartExtractValue(cells, columnMap, fieldName, logger) {
    const expectedIndex = columnMap[fieldName];
    
    if (expectedIndex !== undefined && expectedIndex < cells.length) {
        const cellValue = cells[expectedIndex].textContent.trim();
        const validation = validateCellContent(cellValue, fieldName);
        
        if (validation.valid && validation.score >= 7) {
            return cellValue;
        }
    }
    
    let bestMatch = null;
    let bestScore = 0;
    
    cells.forEach((cell) => {
        const cellValue = cell.textContent.trim();
        if (!cellValue) return;
        
        const validation = validateCellContent(cellValue, fieldName);
        
        if (validation.score > bestScore) {
            bestScore = validation.score;
            bestMatch = cellValue;
        }
    });
    
    if (bestMatch && bestScore >= 5) {
        return bestMatch;
    }
    
    return null;
}

// ============================================
// ?? SCORING DE TABLAS
// ============================================

function scoreTable(table, logger) {
    const rows = Array.from(table.querySelectorAll('tr'));
    
    if (rows.length < 2) return { score: 0, reason: 'Menos de 2 filas' };
    
    let score = 0;
    let headerRow = null;
    let headerRowIndex = -1;
    
    const normalizeHeaderText = (text) => text
        .toLowerCase()
        .trim()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^\w\s]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

    for (let i = 0; i < Math.min(10, rows.length); i++) {
        const cells = getVisibleCells(rows[i]);
        const cellTexts = cells.map(c => normalizeHeaderText(c.textContent || ''));
        
        const hasTicket = cellTexts.some(text => 
            text.includes('ticket') || text.includes('order') || text.includes('posicion')
        );
        
        const hasSymbol = cellTexts.some(text => 
            text.includes('simbolo') || text.includes('symbol')
        );
        
        if (hasTicket && hasSymbol) {
            headerRow = rows[i];
            headerRowIndex = i;
            score += 10;
            break;
        }
    }
    
    if (!headerRow) return { score: 0, reason: 'No tiene headers v�lidos' };
    
    const headerCells = getVisibleCells(headerRow);
    const headerTexts = headerCells.map(c => normalizeHeaderText(c.textContent || ''));
    
    const hasCloseTime = headerTexts.some(text => 
        text.includes('close') || text.includes('cierre') || text.includes('salida') || text.includes('exit')
    );
    if (hasCloseTime) score += 20;
    
    const hasProfit = headerTexts.some(text => 
        text.includes('profit') || text.includes('beneficio') || text.includes('ganancia')
    );
    if (hasProfit) score += 15;
    
    const dataRows = rows.length - headerRowIndex - 1;
    score += Math.min(dataRows * 0.5, 20);
    
    const prevRow = headerRowIndex > 0 ? rows[headerRowIndex - 1] : null;
    if (prevRow) {
        const titleText = prevRow.textContent.toLowerCase().trim();
        
        if (titleText.includes('posiciones') && !titleText.includes('histor')) {
            score += 25;
        }
        
        if (titleText.includes('open') || titleText.includes('abierta')) {
            score -= 30;
        }
    }
    
    return {
        score: score,
        headerRow: headerRow,
        headerRowIndex: headerRowIndex,
        dataRows: dataRows
    };
}

// ============================================
// ?? PARSEO HTML MEJORADO
// ============================================

function parseHTML(content, logger) {
    logger.info('Iniciando parseo de HTML...');
    
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');
    const tables = doc.querySelectorAll('table');
    
    if (tables.length === 0) throw new Error('No se encontraron tablas en el HTML');
    
    logger.info(`${tables.length} tabla(s) encontrada(s)`);
    
    const tableScores = [];
    tables.forEach((table, index) => {
        const analysis = scoreTable(table, logger);
        tableScores.push({ table, index, ...analysis });
        logger.debug(`Tabla ${index + 1}: Score=${analysis.score}`);
    });
    
    tableScores.sort((a, b) => b.score - a.score);
    
    const bestTable = tableScores[0];
    
    if (!bestTable || bestTable.score < 10) {
        throw new Error('No se encontr� ninguna tabla v�lida para parsear trades');
    }
    
    logger.info(`? Tabla seleccionada: #${bestTable.index + 1} (Score: ${bestTable.score})`);
    
    return parseHTMLTable(bestTable.table, bestTable.headerRow, bestTable.headerRowIndex, logger);
}

function parseHTMLTable(table, headerRow, headerRowIndex, logger) {
    const headerCells = getVisibleCells(headerRow);
    const rawHeaders = headerCells.map(cell => cell.textContent.trim());
    
    logger.info(`${rawHeaders.length} columnas visibles detectadas`);
    
    const columnMap = {};
    let dateCount = 0;
    let priceCount = 0;
    
    rawHeaders.forEach((header, index) => {
        const h = header.toLowerCase().trim()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/[^\w\s]/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
        
        if (h.includes('ticket') || h.includes('posicion') || h.includes('order')) {
            columnMap.ticket = index;
        } else if (h.includes('simbolo') || h.includes('symbol')) {
            columnMap.symbol = index;
        } else if (h.includes('tipo') || h.includes('type')) {
            columnMap.type = index;
        } else if (h.includes('volumen') || h.includes('volume') || h.includes('lot')) {
            columnMap.volume = index;
        } else if (h.includes('fecha') || h.includes('time') || h.includes('hora')) {
            dateCount++;
            columnMap[dateCount === 1 ? 'openTime' : 'closeTime'] = index;
        } else if (h.includes('precio') || h.includes('price')) {
            priceCount++;
            columnMap[priceCount === 1 ? 'openPrice' : 'closePrice'] = index;
        } else if (h.includes('s') && h.includes('l')) {
            columnMap.sl = index;
        } else if (h.includes('t') && h.includes('p')) {
            columnMap.tp = index;
        } else if (h.includes('comision') || h.includes('commission')) {
            columnMap.commission = index;
        } else if (h.includes('swap')) {
            columnMap.swap = index;
        } else if (h.includes('beneficio') || h.includes('profit')) {
            columnMap.profit = index;
        }
    });
    
    logger.info('Mapa de columnas:', columnMap);
    
    const trades = [];
    const rows = table.querySelectorAll('tr');
    
    for (let i = headerRowIndex + 1; i < rows.length; i++) {
        const cells = getVisibleCells(rows[i]);
        
        if (cells.length === 0) continue;
        
        const firstCell = cells[0].textContent.toLowerCase().trim();
        
        if (firstCell.includes('total') || firstCell.includes('balance') || 
            firstCell.includes('orden') || firstCell === '') {
            break;
        }
        
        const tradeData = {
            ticket: smartExtractValue(cells, columnMap, 'ticket', logger),
            symbol: smartExtractValue(cells, columnMap, 'symbol', logger),
            type: smartExtractValue(cells, columnMap, 'type', logger),
            volume: smartExtractValue(cells, columnMap, 'volume', logger),
            openPrice: smartExtractValue(cells, columnMap, 'openPrice', logger),
            closePrice: smartExtractValue(cells, columnMap, 'closePrice', logger),
            openTime: smartExtractValue(cells, columnMap, 'openTime', logger),
            closeTime: smartExtractValue(cells, columnMap, 'closeTime', logger),
            commission: smartExtractValue(cells, columnMap, 'commission', logger),
            swap: smartExtractValue(cells, columnMap, 'swap', logger),
            profit: smartExtractValue(cells, columnMap, 'profit', logger)
        };
        
        if (!tradeData.symbol && !tradeData.ticket) continue;
        if (!tradeData.openTime && !tradeData.closeTime) continue;
        
        const trade = parseTradeData(tradeData, logger);
        
        if (trade) {
            trades.push(trade);
        }
    }
    
    logger.info(`? ${trades.length} trades parseados de HTML`);
    
    return trades;
}

// ============================================
// ?? PARSEO DE TRADE DATA (GUARDANDO EN USD)
// ============================================

function parseTradeData(data, logger) {
    try {
        const openDateTime = parseDateTime(data.openTime);
        const closeDateTime = parseDateTime(data.closeTime);
        
        if (!openDateTime && !closeDateTime) return null;
        
        const dateToUse = closeDateTime || openDateTime;
        
        const symbol = normalizeSymbol(data.symbol || '');
        if (!symbol) return null;
        
        const ticket = (data.ticket || generateId()).toString().trim();
        const direction = detectDirection(data.type || '');
        
        const lotSize = cleanNumber(data.volume);
        const entryPrice = cleanNumber(data.openPrice);
        const exitPrice = cleanNumber(data.closePrice);
        const commission = cleanNumber(data.commission) || 0;
        const swap = cleanNumber(data.swap) || 0;
        
        let profitRaw = cleanNumber(data.profit) || 0;
        
        // ?? DETECCI�N INTELIGENTE: Verificar si profit ya incluye comisi�n
        let profitNet = profitRaw;
        let isGross = false;
        
        if ((commission !== 0 || swap !== 0) && profitRaw !== 0) {
            // Calcular qu� ser�a el profit si fuera bruto
            const wouldBeNet = profitRaw + commission + swap;
            
            // Comparar con tolerancia de centavos (redondeo)
            const difference = Math.abs(profitRaw - wouldBeNet);
            
            // ?? Si la diferencia es mayor que 1 centavo por cada $10 de profit
            const tolerance = Math.max(0.01, Math.abs(profitRaw) * 0.001);
            
            if (difference > tolerance) {
                // El profit es BRUTO (no incluye comisi�n/swap)
                profitNet = wouldBeNet;
                isGross = true;
                logger.debug(`Trade ${ticket}: BRUTO detectado (diff=${difference.toFixed(2)}) ? ${profitRaw.toFixed(2)} + (${commission.toFixed(2)}) + (${swap.toFixed(2)}) = ${profitNet.toFixed(2)} USD`);
            } else {
                // El profit ya es NETO (ya incluye comisi�n/swap)
                profitNet = profitRaw;
                logger.debug(`Trade ${ticket}: NETO detectado (diff=${difference.toFixed(2)}) = ${profitNet.toFixed(2)} USD`);
            }
        } else {
            // No hay comisi�n ni swap, o profit es 0
            profitNet = profitRaw;
        }
        
        const trade = {
            id: generateId(),
            ticket: ticket,
            symbol: symbol,
            pair: symbol,
            direction: direction,
            lotSize: lotSize,
            entryPrice: entryPrice,
            exitPrice: exitPrice,
            commission: commission,
            swap: swap,
            profitUSD: profitNet,  // ? SIEMPRE NETO
            date: dateToUse.date,
            entryTime: openDateTime ? openDateTime.time : null,
            exitTime: closeDateTime ? closeDateTime.time : null,
            comment: '',
            tradingViewUrl: null,
            importSource: 'MT4/MT5',
            timestamp: new Date().toISOString()
        };
        
        return trade;
        
    } catch (error) {
        logger.error('Error parseando trade', error);
        return null;
    }
}
// ============================================
// ?? C�LCULO DE % DIN�MICO (PARA M�TRICAS)
// ============================================

function calculatePercentages(trades, balance) {
    if (!balance || balance <= 0) return trades;
    
    return trades.map(trade => ({
        ...trade,
        resultPercent: ((trade.profitUSD || 0) / balance) * 100
    }));
}

// ============================================
// DUPLICADOS
// ============================================

function removeDuplicates(trades, logger) {
    const unique = [];
    const seen = new Set();
    let removed = 0;
    
    for (const trade of trades) {
        const key = `${trade.ticket}_${trade.date}`;
        if (seen.has(key)) {
            removed++;
            continue;
        }
        seen.add(key);
        unique.push(trade);
    }
    
    if (removed > 0) logger.warn(`${removed} duplicado(s) eliminado(s)`);
    
    return unique;
}

// ============================================
// ?? FUNCI�N PRINCIPAL EXPORTADA
// ============================================

export function parseMetaTraderFile(content, options = {}) {
    const logger = new Logger(options.logLevel || 'info');
    
    logger.info('=== MT-PARSER v4.0 - INICIO ===');
    
    const result = {
        success: false,
        trades: [],
        metadata: {
            totalTrades: 0,
            detectedBalance: null,
            detectedFormat: null
        },
        errors: [],
        warnings: []
    };
    
    try {
        const format = detectFormat(content);
        result.metadata.detectedFormat = format;
        
        // ?? SOLO ACEPTAR HTML - RECHAZAR CSV
        if (format !== 'html') {
            result.errors.push({ 
                message: 'Formato no valido. Solo se aceptan archivos HTML. Exporta desde MetaTrader como "Informe detallado" en formato HTML.' 
            });
            return result;
        }
        
        const detectedBalance = detectBalance(content, logger);
        result.metadata.detectedBalance = detectedBalance;
        
        let trades = parseHTML(content, logger);
        
        if (options.removeDuplicates !== false) {
            trades = removeDuplicates(trades, logger);
        }
        
        trades.sort((a, b) => {
            const dateCompare = a.date.localeCompare(b.date);
            if (dateCompare !== 0) return dateCompare;
            return (a.entryTime || '00:00').localeCompare(b.entryTime || '00:00');
        });
        
        const winners = trades.filter(t => t.profitUSD > 0).length;
        const totalProfitUSD = trades.reduce((sum, t) => sum + (t.profitUSD || 0), 0);
        
        result.success = true;
        result.trades = trades;
        result.metadata.totalTrades = trades.length;
        result.metadata.winners = winners;
        result.metadata.losers = trades.length - winners;
        result.metadata.totalProfitUSD = parseFloat(totalProfitUSD.toFixed(2));
        
        logger.info(`? ${trades.length} trades parseados`);
        logger.info(`?? Profit Total: ${totalProfitUSD >= 0 ? '+' : ''}${totalProfitUSD.toFixed(2)} USD`);
        
    } catch (error) {
        logger.error('Error cr�tico', error);
        result.errors.push({ message: error.message });
    }
    
    result.warnings = logger.getLogs().filter(log => log.level === 'warn').map(log => log.message);
    
    return result;
}

export function calculatePercentageResults(trades, balance) {
    return calculatePercentages(trades, balance);
}

export function calculateTradeStatistics(trades, balance = null) {
    if (!trades || trades.length === 0) {
        return {
            totalTrades: 0,
            winners: 0,
            losers: 0,
            winRate: 0,
            totalProfitUSD: 0,
            totalProfitPercent: 0
        };
    }
    
    const winners = trades.filter(t => (t.profitUSD || 0) > 0);
    const losers = trades.filter(t => (t.profitUSD || 0) < 0);
    const totalProfitUSD = trades.reduce((sum, t) => sum + (t.profitUSD || 0), 0);
    
    const stats = {
        totalTrades: trades.length,
        winners: winners.length,
        losers: losers.length,
        winRate: (winners.length / trades.length) * 100,
        totalProfitUSD: parseFloat(totalProfitUSD.toFixed(2))
    };
    
    if (balance && balance > 0) {
        stats.totalProfitPercent = parseFloat(((totalProfitUSD / balance) * 100).toFixed(2));
    }
    
    return stats;
}

export function validateMetaTraderFile(content) {
    const format = detectFormat(content);
    
    if (format === 'html') {
        const parser = new DOMParser();
        const doc = parser.parseFromString(content, 'text/html');
        const tables = doc.querySelectorAll('table');
        return { isValid: tables.length > 0, format };
    }
    
    return { isValid: false, format };
}

export default {
    parseMetaTraderFile,
    calculatePercentageResults,
    calculateTradeStatistics,
    validateMetaTraderFile
};
